import axiosInstance from "@/api/axios-instance";

export async function placeExotelCall(patientPhone: string) {
  const response = await axiosInstance.post("/internal/user/exotel/call", {
    patient_phone: patientPhone,
  });
  if (!response.status.toString().startsWith("2")) {
    throw new Error("Call failed");
  }
  return response.data as { sid: string };
}
